import { clsxm } from "@/utils/clsxm";

interface IProps {
  text: string;
  textColor: string;
  bgColor: string;
  className?: string;
}

const TreatmentLabel = ({ text, textColor, bgColor, className }: IProps) => (
  <div
    style={{
      color: textColor,
      backgroundColor: bgColor,
    }}
    className={clsxm(
      "flex text-[10px] items-center gap-1 rounded-full font-medium px-2 py-[2px] leading-5 sm:leading-6",
      className
    )}
  >
    {text}
  </div>
);

export { TreatmentLabel };
